import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

export type SafeSource = 'html' | 'style' | 'script' | 'url' | 'resourceUrl';

@Pipe({ name: 'safeSource', standalone: true })
export class SafeSourcePipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string, args: SafeSource): SafeHtml | SafeUrl | SafeScript | SafeStyle | SafeResourceUrl {
    switch (args) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        throw new Error(`Unsupported type specified: ${args}`);
    }
  }
}
